import {createContext} from 'react';

export default createContext({
    dataUrl: '/api/header/'
});